import { useApolloClient } from '@speedlo/graphql'
import React from 'react'

import { useRoot } from '../app/useRoot'
import {
  QResolveLocationDocument,
  QResolveLocationQuery,
  QResolveLocationVariables,
} from '../graph/generated'
import { GeoPoint } from '../helpers/gps'

export function useLocationResolverQuery() {
  const { business } = useRoot()

  const apolloClient = useApolloClient()

  const resolver = React.useCallback(
    async (gps: GeoPoint | null, rawInput: Maybe<string>) => {
      const { data } = await apolloClient.query<
        QResolveLocationQuery,
        QResolveLocationVariables
      >({
        query: QResolveLocationDocument,
        variables: {
          address: rawInput,
          ...getResolutionTarget(),
          ...(gps ?? {}),
        },
        fetchPolicy: 'cache-first',
      })

      function getResolutionTarget() {
        if (business.isBrand) {
          return {
            brandId: business.brandId!,
          }
        }
        return {
          branchId: business.branchId!,
        }
      }

      return data
    },
    [apolloClient, business],
  )

  return resolver
}
